import { render, staticRenderFns } from "./KSRShopAccount.vue?vue&type=template&id=51456f3e&"
import script from "./KSRShopAccount.vue?vue&type=script&lang=js&"
export * from "./KSRShopAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports